export default "__VITE_ASSET__Dya4r7fO__"